import { render, staticRenderFns } from "./BlockUserComponent.vue?vue&type=template&id=294c267f&scoped=true&"
import script from "./BlockUserComponent.vue?vue&type=script&lang=js&"
export * from "./BlockUserComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlockUserComponent.vue?vue&type=style&index=0&id=294c267f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c267f",
  null
  
)

export default component.exports